import type { PendingUpload } from "~/shared/store/types";
import { AttachmentPickerDialog } from "../AttachmentPickerDialog";
import type { PerKindCounts, PerKindLimits } from "../types";

import { usePickGeneratedAttachment } from "./usePickGeneratedAttachment";

export interface PickGeneratedDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    chatId: string | null;
    /** Per-kind лимиты режима. */
    limits: PerKindLimits;
    /** Уже в pendingByChat для каждого kind. */
    currentCounts: PerKindCounts;
    onConfirm: (items: PendingUpload[]) => void;
}

export function PickGeneratedDialog({
    open,
    onOpenChange,
    chatId,
    limits,
    currentCounts,
    onConfirm,
}: PickGeneratedDialogProps) {
    const picker = usePickGeneratedAttachment({
        chatId,
        limits,
        currentCounts,
        enabled: open,
    });

    const handleConfirm = () => {
        const items = picker.commit();
        if (items.length === 0) return;
        onConfirm(items);
    };

    return (
        <AttachmentPickerDialog
            open={open}
            onOpenChange={onOpenChange}
            picker={picker}
            onConfirm={handleConfirm}
            i18nPrefix="prompt.pickGenerated"
        />
    );
}
